module.exports = __webpack_public_path__ + "static/media/nature.8326d1ce.svg";